// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app.app-style.v-application[data-v-7e61ad32]{font-family:\"Open Sans\";background-color:#f2f2f2}#app.app-style.v-application[data-v-7e61ad32] .v-application--wrap{min-height:auto}@media(max-width: 768px){#app.app-style.v-application[data-v-7e61ad32]{padding:0}}@media(min-width: 768px){#app.app-style.v-application[data-v-7e61ad32]{padding:30}}", ""]);
// Exports
module.exports = exports;
